import React from "react";
import { Tabs, Tab, Glyphicon, Button, ButtonToolbar } from "react-bootstrap";
import { Navigation, Link } from "react-router";
import FontAwesome from "react-fontawesome";
import TextField from "./account-form-textfield"
import ArrayField from "./account-form-arrayfield"
import StaticField from "./account-form-static";
import LicensesTable from "js/components/account/account-table-license"
import LicensesTableRow from "js/components/account/account-table-license-row"
import SftpAccounts from "js/components/account/account-table-sftp-accounts"
import SshKeyTable from "js/components/account/account-table-sshkey"
import SshKeyTableRow from "js/components/account/account-table-sshkey-row"
import * as config from "../../config";
import UserHandler from "js/utilities/user-handler";
import UserTable from "../account/account-table-user";
import UserTableRow from "../account/account-table-user-row";
import ChecklistRow from "./checklist-row";

export default React.createClass({

  render(){


    var canDownloadLicenses = !this.props.company.hasOverdueInvoice || this.props.company.allowAllLicensing;

    return (
      <div className={"account-table-row application-row " + (this.state.expanded ? 'expanded' : '')}
           key={this.props.key}>

        <div  id={"application" + this.props.applicationNumber} className="application-row-header account-row-header" onClick={this.toggleExpand.bind(this, "application" + this.props.applicationNumber)}>
          <div className="account-table-left">
            <span className="application-name account-name">{this.props.name}</span>
            <span className="hidden-mobile">{this.props.appToken}</span>
          </div>

          <div className="account-table-right">
            <span>
              {this.props.hasUsage &&
              <FontAwesome className="application-toggle green" name="check"/>
              }
            </span>
            <span>
              {this.props.hasLicenseAuthorizations &&
              <FontAwesome className="application-toggle green" name="check"/>
              }
            </span>
            <span>
              <FontAwesome className="application-toggle disabled"
                           name={this.state.expanded ? 'chevron-down' : 'chevron-right'}/>
            </span>
          </div>
        </div>

        {this.state.expanded &&
        <div className="application-row-details">
          <Tabs defaultActiveKey="details" onClick={this.clearStateData}>

            <Tab eventKey="details" title="Details">
              <h4>Your App Name and Key  Identifiers</h4>
              <div className="form-table">
                <TextField
                  label="Application Name"
                  value={this.props.name}
                  entityType="application"
                  entityId={this.props.appToken}
                  field="name"
                  canEdit={this.props.canEdit}
                />
                <StaticField
                  help="Your device Key  identifier "
                  label="Device Key  Identifier"
                  value={this.props.appToken}
                />
                <StaticField
                  help="Your FaceTec Server Key  identifier should only be used in server-side code and should never be shared with anyone, treat this key like a password."
                  label="Server Key  Identifier"
                  value={(this.props.serverToken) ? (this.state.showSecret ? this.props.serverToken :
                    <em onClick={this.showSecret}>Click to show&mdash;treat this key like a
                      password</em>) : "A server key will be granted when FaceTec Server access is enabled"}
                />
                {this.props.requireServerTokenForBiometricsUsage &&
                <StaticField
                  label="Require X-Server-Key-Identifier"
                  value="X-Server-Key-Identifier is required for all biometrics API calls"
                />
                }
              </div>

            </Tab>


            <Tab eventKey="licenses" title="Configure IDs/Domains">
              <h4>Configure Your App IDs and Domains</h4>
              <p>Use the guidelines and form below to configure App's IDs and Domains.  Guidlines:</p>
              <ul>
                <li>
                  <p>
                  Please provide a comma-separated list of Domain Names (Browser), <a target="_blank" href="https://developer.android.com/studio/build/application-id">App IDs (Android)</a>, and <a target="_blank" href="https://developer.apple.com/documentation/appstoreconnectapi/bundle_ids">Bundle IDs (iOS)</a> you will be deploying FaceTec SDKs to.
                  </p>
                </li>
                <li><p>For Package IDs (iOS/Android), you may postfix a “*” to include all application under a specific prefix.</p></li>
                <li><p>For Domains (Browser), subdomains are included automatically, so just use Domains of the form <code>mycompany.com</code></p></li>
                <li><p>You MUST configure ALL App/Bundle IDs (iOS/Android) and Domains (Browser) for your Apps.  For security reasons, FaceTec Production Keys will not initialize unless they are in the Apps you specify.</p></li>
                <li><p><strong>Production Keys are NOT regenerated automatically</strong> if you make a change to the below fields. If you make a change, you <strong>must contact FaceTec to re-generate your Keys</strong>.</p></li>
                <li><p>Changes to the below IDs <strong>DO NOT</strong> affect already-issued Production Keys.</p></li>
                <li><p>Package IDs <strong>are case sensitive</strong>.</p></li>
              </ul>

              <div className="form-table full-width">
                <ArrayField
                  label="Domain Names"
                  value={this.props.domainNames}
                  entityType="application"
                  entityId={this.props.appToken}
                  field="domainNames"
                  canEdit={this.props.canEdit}
                  placeholder="Please separate multiple values with a comma, eg: mydomain.com, myotherdomain.com"
                />
                <ArrayField
                  label={"Package IDs"}
                  value={this.props.packageIds}
                  entityType="application"
                  entityId={this.props.appToken}
                  field="packageIds"
                  canEdit={this.props.canEdit}
                  placeholder="Please separate multiple values with a comma, eg: com.my.app.id, com.my.otherapp.id"
                />
              </div>
            </Tab>

            {(this.props.serverAccessEnabled) &&
              <Tab eventKey="ssh-keys" title="Configure Usage Logs">
                <SshKeyTable
                  row={SshKeyTableRow}
                  sshKeys={this.props.sshKeys}
                  sftpAccounts={this.props.sftpAccounts}
                  appToken={this.props.appToken}
                  canEdit={this.props.canEdit}
                />
              </Tab>
            }

            {(this.props.serverAccessEnabled) &&
            <Tab eventKey="license-authorizations" title="Production Keys">
              <h4>Your Production Keys</h4>

              { ( this.props.company.hasOverdueInvoice && !this.props.company.allowAllLicensing) &&
              <p className="error-message">Your account is past due, please <Link to="/general-questions" className="panel-button">contact FaceTec</Link> to resolve.
                </p>
              }

              { this.props.hasLicenseAuthorizations &&
              <LicensesTable row={LicensesTableRow} dataSource={this.getLicenseAuthorizations()} appToken={this.props.appToken} canDownload={canDownloadLicenses} />
              }

              {!this.props.hasLicenseAuthorizations &&
              <p className="form-pseudo-row">This application does not have any Production Keys. Please see the <Link to="/going-production-overview">Going Production Overview</Link> guide for more information.
              </p>
              }

            </Tab>
            }

            {(this.props.canAdministerUsers && this.props.showApplicationRoles) &&
            <Tab eventKey="external-users" title="External Users">
              {(this.props.sharedWith) &&
              <UserTable
                row={UserTableRow}
                callbackParent={this.onChildChanged}
                dataSource={this.props.sharedWith}
                appToken={this.props.appToken}
                entityType="application"
              />
              }
            </Tab>
            }


          </Tabs>
        </div>
        }
      </div>
    );
  },

  toggleExpand: function(id, e){
    this.setState(prevState => ({
      expanded: !prevState.expanded
    }));
    if(id && id!="") {
      this.context.router.push("/account?link=" + id);
    }
  },


  getInitialState: function() {

    var expanded = false
    if(this.props.lastTwoWeeksUsage > 0) {
      expanded = true
    }

    return {
      expanded: expanded,
      showSecret: false
    }
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired
  },


  /*********************************************************************************************************************
   Building the production checklist
   *********************************************************************************************************************/

  getProductionChecklist: function() {

    var checklistData = [];

    checklistData.push({
      label: "Enable server access",
      status: this.props.serverAccessEnabled,
      offDescription: "The first step to entering production is to contact us and request server-side access.",
      ready: true,
      action: <Link to='/support' target="_blank">Request access</Link>
    });

    checklistData.push({
      label: "Configure domain names and/or package IDs",
      status: (this.props.packageIds.length > 0 || this.props.domainNames.length > 0),
      offDescription: "Enter all domain names and/or app package IDs on the Configure IDs and Domains tab",
      ready: this.props.serverAccessEnabled,
      // action: <Link to='/support' target="_blank">Request access</Link>
    });

    checklistData.push({
      label: "Add an SSH key",
      status: this.props.sshKeys.length > 0,
      offDescription: "Upload an SSH key on the SSH Keys tab",
      ready: this.props.serverAccessEnabled
    });

    checklistData.push({
      label: "Upload a test file",
      status: this.props.sshKeys.length > 0 && this.props.logsFound,
      offDescription: "Use your SFTP Account name and SSH key to upload a test file and confirm you have uploading capability",
      ready: this.props.sshKeys.length > 0
    });

    // I'm not sure about this step and how to indicate that they've requested
    // Lets touch base to be sure we're setting this up correctly
    checklistData.push({
      label: "Receive a Production Key",
      status: this.props.hasLicenseAuthorizations, // Unsure of this step
      offDescription: "Request a Production Key which can be installed in your application",
      ready: this.props.sshKeys.length > 0 && this.props.logsFound,
      action: <Link to='/support' target="_blank">Request a Production Key</Link>
    });

    return(
      <div className="checklist-table">
        {checklistData.map( (item) => {
          return <ChecklistRow {...item} />
        })}
      </div>
    );



  },

  /*********************************************************************************************************************
   Secret Helper
   *********************************************************************************************************************/

  showSecret: function(){
    this.setState({
      showSecret: true
    })
  },

  /*********************************************************************************************************************
   Key  Helpers
   *********************************************************************************************************************/

  /*
   * We're mutating the webservice response here for reasons I don't understand
   * We should really just return whatever we need from the webservice, no reason to tweek it here since this is the only client
   * @TODO: A problem for a less rushed day
   */
  getLicenseAuthorizations: function() {
    var licenseAuthorizations = [];
    _.forEach(this.props.licenseAuthorizations, function(licenseAuthorization, key) {
      if (!_.isEmpty(licenseAuthorization) && licenseAuthorization.isActive) {
        if (key == "mobile") {
          if (licenseAuthorization.packageIds && licenseAuthorization.packageIds[0] != "") {
            var packageId = licenseAuthorization.packageIds.join(", ")
            var expiresDate = licenseAuthorization.expiresDate.split("T")
            licenseAuthorizations.push({
              "id": licenseAuthorization.id,
              "type": key,
              "name": packageId,
              "expiresDate": expiresDate[0]
            });
          }
        } else if (key == "web") {
          if (licenseAuthorization.domainNames && licenseAuthorization.domainNames[0] != "") {
            var domainName = licenseAuthorization.domainNames.join(", ")
            var expiresDate = licenseAuthorization.expiresDate.split("T")
            licenseAuthorizations.push({
              "id": licenseAuthorization.id,
              "type": key,
              "name": domainName,
              "expiresDate": expiresDate[0]
            });
          }
        } else if (key == "server") {
          if (licenseAuthorization.serverAccessEnabled) {
            var expiresDate = licenseAuthorization.expiresDate.split("T")
            licenseAuthorizations.push({
              "id": licenseAuthorization.id,
              "type": key,
              "name": "Not Applicable for Server SDK",
              "expiresDate": expiresDate[0]
            });
          }
        }
      }
    });
    return licenseAuthorizations;
  },


});



// WEBPACK FOOTER //
// ./src/js/components/account/account-table-application-row.jsx